/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetCardTransactionDetailsResponse,
  UtxCardTransactionGetCardTransactionsByCardIdParams,
  CardTransactionResponse,
  CardTransactionsReportRequest
} from './schema'



export const utxCardTransactionGetCardTransactionsByCardId = (
    id: string,
    params?: UtxCardTransactionGetCardTransactionsByCardIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardTransactionDetailsResponse>> => {
    return axios.get(
      `/card/${id}/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardTransactionGetCardTransactionsByCardIdQueryKey = (id: string,
    params?: UtxCardTransactionGetCardTransactionsByCardIdParams,) => [`/card/${id}/transactions`, ...(params ? [params]: [])];

    
export type UtxCardTransactionGetCardTransactionsByCardIdQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardTransactionGetCardTransactionsByCardId>>>
export type UtxCardTransactionGetCardTransactionsByCardIdQueryError = AxiosError<unknown>

export const useUtxCardTransactionGetCardTransactionsByCardId = <TData = Awaited<ReturnType<typeof utxCardTransactionGetCardTransactionsByCardId>>, TError = AxiosError<unknown>>(
 id: string,
    params?: UtxCardTransactionGetCardTransactionsByCardIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardTransactionGetCardTransactionsByCardId>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardTransactionGetCardTransactionsByCardIdQueryKey(id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardTransactionGetCardTransactionsByCardId>>> = ({ signal }) => utxCardTransactionGetCardTransactionsByCardId(id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardTransactionGetCardTransactionsByCardId>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardTransactionGetCardTransaction = (
    cardId: string,
    transactionId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardTransactionResponse>> => {
    return axios.get(
      `/card/${cardId}/transactions/${transactionId}`,options
    );
  }


export const getUtxCardTransactionGetCardTransactionQueryKey = (cardId: string,
    transactionId: string,) => [`/card/${cardId}/transactions/${transactionId}`];

    
export type UtxCardTransactionGetCardTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardTransactionGetCardTransaction>>>
export type UtxCardTransactionGetCardTransactionQueryError = AxiosError<unknown>

export const useUtxCardTransactionGetCardTransaction = <TData = Awaited<ReturnType<typeof utxCardTransactionGetCardTransaction>>, TError = AxiosError<unknown>>(
 cardId: string,
    transactionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardTransactionGetCardTransaction>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardTransactionGetCardTransactionQueryKey(cardId,transactionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardTransactionGetCardTransaction>>> = ({ signal }) => utxCardTransactionGetCardTransaction(cardId,transactionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardTransactionGetCardTransaction>>, TError, TData>(queryKey, queryFn, {enabled: !!(cardId && transactionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardTransactionDownloadReport = (
    cardTransactionsReportRequest: CardTransactionsReportRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardTransactionResponse>> => {
    return axios.post(
      `/card/transactions/download-report`,
      cardTransactionsReportRequest,options
    );
  }



    export type UtxCardTransactionDownloadReportMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardTransactionDownloadReport>>>
    export type UtxCardTransactionDownloadReportMutationBody = CardTransactionsReportRequest
    export type UtxCardTransactionDownloadReportMutationError = AxiosError<unknown>

    export const useUtxCardTransactionDownloadReport = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardTransactionDownloadReport>>, TError,{data: CardTransactionsReportRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardTransactionDownloadReport>>, {data: CardTransactionsReportRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardTransactionDownloadReport(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardTransactionDownloadReport>>, TError, {data: CardTransactionsReportRequest}, TContext>(mutationFn, mutationOptions)
    }
    